/* eslint-disable */
import {AdTemplate} from './AdTemplate';
import {ReactComponent} from './ReactComponent';
/**
* @description Interface for Avensia.Commerce.Web.Models.Ads.Ad
*/
export interface Ad extends ReactComponent {
	adTemplate: AdTemplate;
	ticket: string;
	title: string;
	url: string;
	googleAnalyticsKey: string;
	googleAnalyticsName: string;
}
export const isAd = (model: unknown): model is Ad => (model as Ad).component === 'Bygghemma.Commerce.Web.Models.Ads.Ad';

